import { BLOG_METADATA_ENTRIES } from './blog-metadata';
import { type BlogMetaData } from './blog-metadata/types';
import { PageUrl } from './PageUrl';

export { BLOG_CATEGORY, BLOG_CATEGORY_LABELS, type BlogCategory, type BlogMetaData } from './blog-metadata/types';

export const BlogsMetadata: Record<string, BlogMetaData> = BLOG_METADATA_ENTRIES;

const BLOG_METADATA_BY_SLUG: Record<string, BlogMetaData | undefined> = Object.fromEntries(
  Object.values(BlogsMetadata).map((metadata) => [metadata.filePath.slice(PageUrl.BLOG_ROOT.length, -1), metadata])
);

export const getBlogThumbnailBySlug = (slug: string): string | undefined => BLOG_METADATA_BY_SLUG[slug]?.thumbnailUrl;

export const getBlogTitleBySlug = (slug: string): string | undefined => BLOG_METADATA_BY_SLUG[slug]?.title;
